<template>

  <div class="row">

    <div class="form-group col-md-12">
      <div class="xml-authenticator-title">
        <h5 class="mr-3">
          <strong @click="$emit('cancel')" style="cursor: pointer">
            <arrow-left-icon class="pb-1"/>
          </strong>
        </h5>
        <h3>{{ title }}</h3>
      </div>
      <hr>
    </div>

    <div class="form-group col-md-12">
      <label for="xml-authenticator-name">Nome do XmlAuthenticator</label>
      <input v-model="currentGroup.name" type="text" class="form-control input" id="xml-authenticator-name">
    </div>

    <div class="form-group col-md-12">
      <label for="xml-authenticator-description">Descrição do XmlAuthenticator</label>
      <input v-model="currentGroup.description" type="text" class="form-control input" id="xml-authenticator-description">
    </div>

    <div class="form-group col-md-12">
      <BkpsCheckBox v-model="currentGroup.enable">
        <label class="ml-2">Ativo</label>
      </BkpsCheckBox>
    </div>

    <div class="form-group col-md-12">
      <label for="xml-authenticator-url" class="mr-2">HOSTNAME do Autenticador</label>
      <InfoIcon style="color: red" v-tooltip.right='`HOSTNAME deve conter "http://" ou "https://" para ser uma URL válida.`'/>
      <input v-model="currentGroup.payload.url" type="text" class="form-control input" id="xml-authenticator-url">
    </div>

    <div class="form-group col-md-12">
      <label for="xml-authenticator-token" class="mr-2">Token do Autenticador</label>
      <InfoIcon style="color: red" v-tooltip.right='`Token que será inserido no container.`'/>
      <input v-model="currentGroup.payload.token" type="text" class="form-control input" id="xml-authenticator-token">
    </div>

    <div v-if="optionsCompanies.length > 0" class="form-group col-md-12">
      <label for="xml-authenticator-company-ids" class="mr-2">Empresas vinculadas</label>
      <Select2 v-model="currentGroup.companyIds" :options="optionsCompanies"
               id="xml-authenticator-company-ids"/>
    </div>

    <div class="form-group col-md-12 mb-1">
      <button class="btn btn-primary mr-2" @click="$emit('saveAndClose', currentXmlAuthenticator)">
        {{ 'btn.save' | t }}
      </button>
      <button class="btn btn-primary mr-2" @click="$emit('save', currentXmlAuthenticator)">
        {{ 'btn.apply' | t }}
      </button>
      <button class="btn btn-outline-red mr-2" @click="$emit('cancel')">
        {{ 'btn.cancel' | t }}
      </button>
      <button v-if="persisted" class="btn btn-outline-red" @click="$emit('deleteXmlAuthenticator', currentXmlAuthenticator)">
        {{ 'btn.delete' | t }}
      </button>
    </div>

    <div v-if="persisted" class="form-group col-md-12">
      <hr>
      <hr>
      <button @click="testURL()" class="btn btn-outline mb-2 mr-2">Testar "/health"</button>
      <button @click="testURL('companies')" class="btn btn-outline mb-2 mr-2">Testar "/companies"</button>
      <br>
      <textarea :rows="responseRows" :value="response" class="form-control"/>
    </div>

  </div>
</template>

<script>
  import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
  import Formatter from '@/models/Formatter'
  import GlobalLoading from '@/mixins/GlobalLoading'
  import Select2 from '@/components/shares/Select2'
  import { ArrowLeftIcon, InfoIcon } from 'vue-feather-icons'

  export default {
    components: { ArrowLeftIcon, BkpsCheckBox, InfoIcon, Select2 },
    computed: {
      persisted() {
        return this.currentGroup.id
      },
      responseRows() {
        return Math.max(2, this.response.match(/\n/g)?.length)
      },
      title() {
        return this.persisted ? 'Editar' : 'Novo'
      }
    },
    created() {
      this.setCurrentData()
      this.findAllCompanies()
    },
    data() {
      return {
        currentGroup: {},
        currentXmlAuthenticator: {},
        optionsCompanies: [],
        response: '',
        showModal: false
      }
    },
    methods: {
      findAllCompanies() {
        const params = {
          per_page: 1000,
          q: { type: ['parent', 'subsidiary'] }
        }

        this.openGlobalLoad()
        this.axios.get('companies', { params: params })
          .then(response => {
            this.optionsCompanies = response.data.map(c => {
              return {
                label: `${c.name} - ${Formatter.cnpj(c.cnpj)}`,
                value: c.id
              }
            })
          })
        .finally(() => this.closeGlobalLoad())
      },
      setCurrentData() {
        this.currentXmlAuthenticator = {...this.xmlAuthenticator}
        if (!this.currentXmlAuthenticator.group)
          this.$set(this.currentXmlAuthenticator, 'group', { enable: true })

        this.currentGroup = this.currentXmlAuthenticator.group

        if (this.currentGroup.payload === null || !('payload' in this.currentGroup))
          this.$set(this.currentGroup, 'payload', {})
      },
      testURL(path = '') {
        const token = this.currentGroup.payload?.token
        const url = this.currentGroup.payload.url + path

        this.response = ''
        fetch(url, { headers: { TOKEN: token } })
          .then(async response => {
            let resp = await response.text()
            try {
              resp = JSON.parse(resp)
            } catch (e) {
              // ignore
            }

            return {
              http_status: response.status,
              response: resp
            }
          })
          .then(json => this.response = JSON.stringify(json, null, 2))
          .catch(e => this.response = JSON.stringify({ error: e.message }, null, 2))
      }
    },
    mixins: [GlobalLoading],
    name: 'Form',
    props: {
      xmlAuthenticator: { required: true, type: Object }
    },
    watch: {
      'xmlAuthenticator.group'() {
        this.setCurrentData()
      }
    }
  }
</script>

<style scoped>
  .xml-authenticator-title {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
</style>